<template>
    <el-container>
        <el-header height="80px">
          <el-row type="flex" class="row-bg" justify="space-between">
            <el-col :span="6">
              <div class="leftCenterBox">
                <img src="../assets/pLogo.png" alt="" class="leftmagin">
              </div>
            </el-col>
            <el-col :span="6">
              <div class="centerBox">
                <h2>普来特富保养系统管理平台</h2>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="rightCenterBox ">
                  <el-link type="primary" class="whiteText" @click="logout"> 退出登录</el-link>
                  <span class="rightmagin whiteText"> 欢迎您 {{loginName}}！</span>
                  <el-link type="primary" class="rightmagin whiteText" href="https://pltfmc.platform-cn.com/pltfmtc/static/app/维保app测试版.apk"> 点击下载最新版维保App</el-link>
              </div>
            </el-col>
          </el-row>
        </el-header>
        <el-container>
            <el-aside width="200px">
              <el-menu :default-active="activeIndex" >
                <el-menu-item index="1" @click="toNotice" v-if="this.authPages.includes('1')  ">
                  <i class="el-icon-menu"></i>
                  <span slot="title">通知公告管理</span>
                </el-menu-item>
                <el-menu-item index="2" @click="toParts"  v-if="this.authPages.includes('2') ">
                  <i class="el-icon-menu"></i>
                  <span slot="title">备件图片维护</span>
                </el-menu-item>
                <el-menu-item index="3" @click="toContracts"  v-if="this.authPages.includes('3')   " >
                  <i class="el-icon-menu"></i>
                  <span slot="title">维修合约查询</span>
                </el-menu-item>
                <el-menu-item index="4" @click="toIssues"  v-if="this.authPages.includes('4') ">
                  <i class="el-icon-menu"></i>
                  <span slot="title">故障建档管理</span>
                </el-menu-item>
                <el-menu-item index="5" @click="toSignRecord" v-if="this.authPages.includes('5') " >
                  <i class="el-icon-menu"></i>
                  <span slot="title">保养签到查询</span>
                </el-menu-item>
                <el-menu-item index="6" @click="toLoginRecord" v-if="this.authPages.includes('6') ">
                  <i class="el-icon-menu"></i>
                  <span slot="title">登录信息查询</span>
                </el-menu-item>
                <el-menu-item index="7"  @click="toMfgManager" v-if="this.authPages.includes('7') ">
                  <i class="el-icon-menu"></i>
                  <span slot="title">作番信息管理</span>
                </el-menu-item>
                <el-menu-item index="8"  v-if="this.authPages.includes('8')" @click="toInvoiceUpload">
                  <i class="el-icon-menu"></i>
                  <span slot="title">临时发票上传</span>
                </el-menu-item>
                <el-menu-item index="9" @click="toSignPlan" v-if="this.authPages.includes('9') ">
                  <i class="el-icon-menu"></i>
                  <span slot="title">维保计划管理</span>
                </el-menu-item>
              </el-menu>
            </el-aside>
            <el-main ref="mainDom">
              <router-view></router-view>
            </el-main>
        </el-container>
    </el-container>
</template>

<script>
import router from '../router'
import request from '@/lib/utils'
import { screenResize } from '../lib/screenResize'

export default {
  name: 'Layout',
  data () {
    return {
      activeIndex: '1',
      windowHeight: '3000px',
      loginName: '',
      clientId: '',
      departIds: '',
      authPages: []
    }
  },
  created () {
  },
  methods: {
    toNotice () {
      if (this.activeIndex !== '1') {
        router.push('/notice')
        this.activeIndex = '1'
        sessionStorage.setItem('activeIndex', this.activeIndex)
      }
    },
    toParts () {
      if (this.activeIndex !== '2') {
        router.push('/parts')
        this.activeIndex = '2'
        sessionStorage.setItem('activeIndex', this.activeIndex)
      }
    },
    toContracts () {
      if (this.activeIndex !== '3') {
        router.push('/contracts')
        this.activeIndex = '3'
        sessionStorage.setItem('activeIndex', this.activeIndex)
      }
    },
    toIssues () {
      if (this.activeIndex !== '4') {
        router.push('/issues')
        this.activeIndex = '4'
        sessionStorage.setItem('activeIndex', this.activeIndex)
      }
    },
    toSignRecord () {
      if (this.activeIndex !== '5') {
        router.push('/signRecord')
        this.activeIndex = '5'
        sessionStorage.setItem('activeIndex', this.activeIndex)
      }
    },
    toLoginRecord () {
      if (this.activeIndex !== '6') {
        router.push('/loginRecord')
        this.activeIndex = '6'
        sessionStorage.setItem('activeIndex', this.activeIndex)
      }
    },
    toMfgManager () {
      if (this.activeIndex !== '7') {
        router.push('/mfgManager')
        this.activeIndex = '7'
        sessionStorage.setItem('activeIndex', this.activeIndex)
      }
    },
    toInvoiceUpload () {
      if (this.activeIndex !== '8') {
        router.push('/invoiceUpload')
        this.activeIndex = '8'
        sessionStorage.setItem('activeIndex', this.activeIndex)
      }
    },
    toSignPlan () {
      if (this.activeIndex !== '9') {
        router.push('/signPlan')
        this.activeIndex = '9'
        sessionStorage.setItem('activeIndex', this.activeIndex)
      }
    },
    logout () {
      localStorage.removeItem('auth-token')
      sessionStorage.removeItem('activeIndex')
      router.push('/login')
    },
    initAuthPages (loginName, clientId, departIds) {
      if (departIds !== 'manager') {
        this.authPages = []
        return
      }
      if (this.loginName === 'admin') {
        this.authPages = ['1', '2', '3', '4', '5', '6', '7', '8', '9']
        return
      }
      if (this.loginName === '胡卉' || this.loginName === '沈霞') {
        this.authPages = ['8']
        this.toInvoiceUpload()
        return
      }
      if (this.loginName === '王萍') {
        this.authPages = ['1', '2', '3', '4', '5', '6', '7', '9']
        return
      }
      if (this.loginName === '赵东华' || this.loginName === '彭林辉' || this.loginName === '李跃进') {
        this.authPages = ['5', '9']
        this.toSignRecord()
        return
      }
      if (this.loginName === '蒋荣刚') {
        this.authPages = ['2']
        this.toParts()
        return
      }
      if (this.loginName === '陆兵') {
        this.authPages = ['3', '4', '5', '6', '7']
        return
      }
      if (this.clientId) {
        this.authPages = ['4', '5', '6', '7']
        this.toSignRecord()
        return
      }
      this.authPages = ['1', '2', '3', '4', '5', '6', '7', '9']
      this.toIssues()
    }
  },
  mounted () {
    screenResize()
    const that = this
    if (sessionStorage.getItem('activeIndex')) {
      that.activeIndex = sessionStorage.getItem('activeIndex')
    }
    request.get('/user/queryLoginUser').then(res => {
      that.loginName = res.obj.realName
      that.clientId = res.obj.clientId
      that.departIds = res.obj.deptIds
      that.initAuthPages(that.loginName, that.clientId, that.departIds)
    }
    )
  }
}

</script>

<style>

.el-header{
  background-color: #4b5cc4;
  text-align: center;
  padding: 0px;
  z-index: 1000;
}

.el-header h2{
  color: white;
  font-size: 20px;
}

.el-aside{
  background-color: #4b5cc4;
  line-height: 200px;
  text-align: center;
  height: 100%;
}

.el-main{
  background-color: #E9EEF3;
  color: #333;
}

.el-container{
  margin: 0px;
  padding: 0px;
  height: 100%;
}

.el-menu{
  height: 3000px;
  background-color: #4b5cc4;
}

.el-menu-item{
  background-color:#4b5cc4 ;
  color:white
}

.el-menu-item i{
  color:white
}

.leftCenterBox{
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items:center;
  height: 80px;
}

.rightCenterBox{
  display: flex;
  flex-direction: row-reverse;
  flex-wrap: nowrap;
  align-items: center;
  height: 80px;
}

.centerBox{
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: center;
  height: 80px;
}

.leftmagin{
  margin-left: 20px;
}

.rightmagin{
  margin-right: 20px;
}

.whiteText{
  color: white;
  font-size: large;
}

</style>



// WEBPACK FOOTER //
// src/page/Layout.vue